import api from '@shared/services/api.js';
const baseApi = '/nli';

export default {
  baseApi: baseApi,
  trafficCop: async (body, options = {}) => {
    return api.post(`${baseApi}/traffic-cop`, body, options);
  },
  translateJson: async (body, options = {}) => {
    return api.post(`${baseApi}/translation`, body, options);
  },
  translateBooleanJson: async (body, options = {}) => {
    return api.post(`${baseApi}/translation-boolean`, body, options);
  },
  postRuleEdit: async (body, options = {}) => {
    return api.post(`${baseApi}/rule-edit`, body, options);
  },
  ruleTest: async (body, options = {}) => {
    return api.post(`${baseApi}/rule-test`, body, options);
  },
  contextualize: async (body, options = {}) => {
    return api.post(`${baseApi}/contextualizer`, body, options);
  },
  normalizeAndTag: async (body, options = {}) => {
    return api.post(`${baseApi}/normalization-tagger`, body, options);
  },
  selectColumns: async (body, options = {}) => {
    return api.post(`${baseApi}/column-selector`, body, options);
  },
  semanticMatch: async (body, options = {}) => {
    return api.post(`${baseApi}/semantic-match`, body, options);
  },
  optionSelection: async (body, options = {}) => {
    return api.post(`${baseApi}/option-selection`, body, options);
  },
  nameExtraction: async (body, options = {}) => {
    return api.post(`${baseApi}/name-extraction`, body, options);
  },
  scenarioAnalysis: async (body, options = {}) => {
    return api.post(`/pe/api/scenario-analysis/`, body, options);
  },
  nearMiss: async (body, options = {}) => {
    return api.post(`/pe/api/near-miss/`, body, options);
  },
  nearMissRequirementList: async (body, options = {}) => {
    return api.post(`${baseApi}/near-miss-requirement-list`, body, options);
  },
  summarize: async (body, options = {}) => {
    return api.post(`${baseApi}/summarization`, body, options);
  },
  trackMessage: async (body, options = {}) => {
    return api.post(`${baseApi}/messages`, body, options);
  },
  trackMessageAction: async (messageId, body, options = {}) => {
    return api.patch(
      `${baseApi}/messages/${messageId}/add-action/`,
      body,
      options,
    );
  },
  transcribeAudio: async (audioBase64, messageId = null) => {
    return api.post(
      '/nli/audio-transcription',
      {
        audio: {
          data: audioBase64,
        },
        model: 'whisper-1',
        message_id: messageId,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  },
  updateMessage: async (messageId, body, options = {}) => {
    return api.patch(`/nli/messages/${messageId}/`, body, options);
  },
};
